import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SisLoader from "../../../../../widgets/loader";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import { updateSelectedParameters } from "../../../../../utils/ResponseConver";
import { LngCargo } from "../../components/CargoMachinCom/LngCargo";

export const LngCargoCompressorList = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [LNG_Data, set_LNG_Data] = useState([]);

  const GET_SHIP_LNG_LISTS = async () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);

      post(ApiURL.list_cargo_machinery_lng_st, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const updatedData = res.lng_cargo_parameters_data.map((item) => ({
            ...item,
          }));

          const updatedDataWithFormattedParams = updatedData.map((item) => ({
            ...item,
            selected_parameters: updateSelectedParameters(item?.selected_parameters),
          }));

          set_loader(false);
          set_LNG_Data(updatedDataWithFormattedParams);
        }
      });

      set_loader(false);
    } catch (error) {
      set_loader(false);
      console.error("Error BWT list:", error);
    }
  };



  useEffect(() => {
    GET_SHIP_LNG_LISTS();
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {LNG_Data && LNG_Data?.length > 0 ? (
              <>
                {LNG_Data?.map((_items) => (
                  <LngCargo
                    key={_items.id} // add key for performance
                    eng_log_basic_id={eng_log_basic_id}
                    _items={_items}
                  />
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};
